import { makeUseClient } from './makeUseClient';
const useEventsWrapped = makeUseClient(client => client.frameworkTypes.getEvents);
export const useEventTypes = (args = undefined) => useEventsWrapped(args);
const useObjectsWrapped = makeUseClient(client => client.frameworkTypes.getObjects);
export const useObjectTypes = (args = undefined) => useObjectsWrapped(args);
export const useProperty = makeUseClient(client => client.properties.getProperty);